export const SIDEVIEW_TEST_ID = 'side-view'
export const MAIN_FRAME_ID = 'main-frame'
